import React from "react";
import { Checkbox } from "@my-scoot/component-library-legacy";
import moment from "moment";
import { Field } from "react-final-form";
import ExlyModal from "common/Components/ExlyModal";

const sameValue = (a, b) => String(a) === String(b);

const sourceLabel = (value, showDates) => {
  if (value === null || value === undefined || value === "") return "";
  return showDates
    ? moment(value, "YYYY-MM-DD").format("DD MMMM YYYY")
    : moment().day(value).format("dddd");
};

const targetLabel = (value, showDates) =>
  showDates
    ? moment(value, "YYYY-MM-DD").format("DD MMMM YYYY")
    : moment().day(value).format("dddd");

export default function CopyTime({
  weekdays = [],
  copyFrom,
  onClose,
  isOpen,
  onCopy,
  showDates = false,
}) {
  const [selectedDays, setSelectedDays] = React.useState([]);

  // The source row is already set up — it can't be copied onto itself.
  const targets = weekdays.filter((day) => !sameValue(day, copyFrom));
  const allSelected =
    targets.length > 0 && targets.every((day) => selectedDays.includes(day));

  const checkAll = (event) => {
    setSelectedDays(event.target.checked ? targets : []);
  };

  const handleCheck = (event, day) => {
    if (selectedDays.includes(day)) {
      setSelectedDays(selectedDays.filter((d) => !sameValue(d, day)));
    } else {
      setSelectedDays([...selectedDays, day]);
    }
  };

  const fromLabel = sourceLabel(copyFrom, showDates);

  return (
    <ExlyModal
      title={fromLabel ? `Copy ${fromLabel}'s Times To` : "Copy Times To..."}
      open={isOpen}
      primaryBtnText="Apply"
      secondaryBtnText="Cancel"
      onClose={onClose}
      onSecondaryBtnClick={onClose}
      onPrimaryBtnClick={() => onCopy(selectedDays)}
    >
      <div className="py-3" style={{ maxWidth: "400px", width: "100%" }}>
        {targets.length === 0 ? (
          <p className="tw-m-0 tw-text-[13px] tw-text-gray-500">
            No other rows to copy to yet. Add another day or date first.
          </p>
        ) : (
          <>
            <div className="d-flex justify-content-between pb-2">
              <div>Select All</div>
              <div>
                <Field
                  name="copy_select_all"
                  component={Checkbox}
                  size="large"
                  checked={allSelected}
                  onChange={checkAll}
                />
              </div>
            </div>
            {targets.map((day, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <div className="d-flex justify-content-between pb-2" key={index}>
                <Field
                  name={`weekday_${day}`}
                  component={Checkbox}
                  size="large"
                  label={targetLabel(day, showDates)}
                  value={day}
                  checked={selectedDays.includes(day)}
                  onChange={(event) => handleCheck(event, day)}
                />
              </div>
            ))}
          </>
        )}
      </div>
    </ExlyModal>
  );
}
